document.addEventListener('DOMContentLoaded', () => {
  const noteField = document.querySelector('#Cart-note');
  if (!noteField) return;

  // Fehlerbox nach dem Feld
  let errorBox = document.querySelector('#cart-note-required-error');
  if (!errorBox) {
    errorBox = document.createElement('div');
    errorBox.id = 'cart-note-required-error';
    errorBox.style.marginTop = '8px';
    errorBox.style.fontSize = '0.95em';
    errorBox.style.fontWeight = '600';
    errorBox.style.color = '#b00020';
    errorBox.style.display = 'none';
    noteField.insertAdjacentElement('afterend', errorBox);
  }

  const showError = () => {
    errorBox.textContent = 'Bitte trage ein Abholdatum ein.';
    errorBox.style.display = 'block';
    noteField.setAttribute('aria-invalid', 'true');
    noteField.focus();
  };

  const clearError = () => {
    errorBox.style.display = 'none';
    noteField.removeAttribute('aria-invalid');
  };

  const isEmpty = () => noteField.value.trim().length === 0;

  noteField.addEventListener('input', () => {
    if (!isEmpty()) clearError();
  });

  // Fängt ALLES ab: normale Buttons, Links /checkout, dynamische Checkout Buttons
  document.addEventListener(
    'click',
    (e) => {
      const target = e.target.closest('button[name="checkout"], a[href*="/checkout"], .cart__checkout-button');
      if (!target) return;

      if (isEmpty()) {
        e.preventDefault();
        e.stopPropagation();
        showError();
      }
    },
    true
  );
});
